module.exports = __webpack_public_path__ + "img/page1-min.0ffc180c.jpg";